/**
 * @file orderAudio.service.ts
 * @description Acoustic alerts service for new kitchen tickets and urgent alerts.
 */

// Sound chime for new incoming orders (Kitchen service bell)
const KITCHEN_BELL_URL = 'https://assets.mixkit.co/active_storage/sfx/1435/1435-preview.mp3';

let audioInstance: HTMLAudioElement | null = null;

export const playNewOrderAlert = (): void => {
  try {
    if (typeof window === 'undefined') return;
    if (!audioInstance) {
      audioInstance = new Audio(KITCHEN_BELL_URL);
    }
    audioInstance.currentTime = 0;
    audioInstance.play().catch(err => {
      // Browsers may block audio before first user interaction
      console.warn('[orderAudio.service] Audio autoplay prevented:', err);
    });
  } catch (error) {
    console.error('[orderAudio.service] Failed to play audio:', error);
  }
};
